import { InlineTask } from './inlineTask.types'

export const createInlineTask = ({
  name,
  taskReferenceName,
  inputParameters
}: Omit<InlineTask, 'type'>): InlineTask => {
  return {
    type: 'INLINE',
    name,
    taskReferenceName,
    inputParameters
  }
}
